import styled, { css } from "styled-components";
const StyledFieldHelp = styled.span`
  display: block;
  flex: 1;
  margin-top: 8px;
  white-space: pre-wrap;

  ${({
  labelInline,
  labelWidth
}) => labelInline && css`
      margin-left: ${labelWidth}%;
      padding-left: 0;
    `}
`;
export default StyledFieldHelp;